import { AuthSession } from "@aws-amplify/core";
import { writable } from "svelte/store";

export const sessionStore = writable<Promise<AuthSession | undefined>>();
